import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
    name: 'modal',
    initialState: { 
        isShow: false
    },
    reducers: {
        createModal: (state, action) => {
            state.isShow = true;
        },
        closeModal: (state, action) => {
            state.isShow = false;
        }
    }
});


export const modalActions = modalSlice.actions;
export default modalSlice;